import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./index.css";
import App from "./App";
import SessionCreatorPage from "./pages/SessionCreatorPage";
import Home from "./pages/Home";
import { SessionChooser } from "./pages/SessionChooser";
import SessionPage from "./pages/SessionPage";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginRequiredPage from "./pages/LoginRequiredPage";
import { NavContextProvider } from "./contexts/NavProvider";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/solo",
        element: (
          <ProtectedRoute>
            <SessionCreatorPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/join-create-session",
        element: (
          <ProtectedRoute>
            <SessionChooser />
          </ProtectedRoute>
        ),
      },
      {
        path: "/session/:sessionId",
        element: (
          <ProtectedRoute>
            <SessionPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/login-required",
        element: <LoginRequiredPage />,
      },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <NavContextProvider>
      <RouterProvider router={router} />
    </NavContextProvider>
  </StrictMode>
);
